import { useQuery } from "@tanstack/react-query";
import { queueApi } from "@bw/shared/api";
import { queryKeys } from "../../../common/query/queryClient";

const PARTY_FOREGROUND_REFRESH_MS = 15_000;

/**
 * A single party's detail + roster (GET /queue/party/{partyId}).
 *
 * Keyed by the party id so each party is card-isolated. Disabled until a
 * partyId is present (the route param may be empty on first render). The roster
 * (`members`), `code`, and `status` are server truth — the page renders them
 * verbatim. An invite / cancel mutation invalidates `party.detail(partyId)` so
 * the roster re-reads the server's truth.
 */
export function useParty(partyId: string) {
  return useQuery({
    queryKey: queryKeys.party.detail(partyId),
    queryFn: () => queueApi.getParty(partyId),
    enabled: Boolean(partyId),
    refetchInterval: PARTY_FOREGROUND_REFRESH_MS,
    refetchIntervalInBackground: false,
    refetchOnMount: "always",
    refetchOnWindowFocus: "always",
    refetchOnReconnect: "always",
  });
}
